// extracted by mini-css-extract-plugin
export default {"admin_content_area":"shippingPolicy_admin_content_area__auhbS","modal_root":"shippingPolicy_modal_root__bDGh1"};